import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React, { useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { BannerCloseTypes, BannerKey } from '../../../banners/types'
import { NotificationsNone } from '@mui/icons-material'
import { Button } from '@mui/material'
import ActiveVariableDynamicPowerPriceAlertModal from './ActiveVariableDynamicPowerPriceAlertModal'
import { Banner } from 'src/Components/banner'
import { useDynamicPowerPriceAlertBannerConditions } from '../../hooks/use-variable-dynamic-power-price-alert-banner-conditions'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      gap: theme.spacing(2),
    },
  },
  icon: {
    color: theme.palette.warning.main,
    height: 30,
    width: 30,
  },
  button: {
    boxShadow: 'none',
    width: 'max-content',
    marginLeft: 'auto',
    paddingLeft: theme.spacing(4),

    '&:hover': {
      boxShadow: theme.effectStyles.shadowMain,
    },
  },
}))

/**
 * This is a banner that is shown if variable dynamic power price is
 * enabled but country is not Germany or Netherland
 */
const ActiveVariableDynamicPowerPriceAlertBanner: React.FC = () => {
  const { t } = useCustomTranslation()
  const [showInfoModal, setShowInfoModal] = useState(false)
  const { classes } = useStyles()
  const isBannerVisible = useDynamicPowerPriceAlertBannerConditions()

  if (!isBannerVisible) return null

  return (
    <>
      <Banner
        i18nKey="systemSettings.active-vdpp-alert-banner.title"
        button={
          <Button className={classes.button} color="warning" variant="contained" onClick={() => setShowInfoModal(true)}>
            {t('referral.banner.button')}
          </Button>
        }
        icon={<NotificationsNone className={classes.icon} />}
        bannerKey={BannerKey.ActiveVariableDynamicPowerPriceAlertBanner}
        closeType={BannerCloseTypes.permanentOrTemporary}
        containerStyle={classes.containerStyle}
      />
      <ActiveVariableDynamicPowerPriceAlertModal isVisible={showInfoModal} handleClose={() => setShowInfoModal(false)} />
    </>
  )
}

export default ActiveVariableDynamicPowerPriceAlertBanner
